// extracted by mini-css-extract-plugin
module.exports = {"inputs":"MedicationConstructor_inputs__3Htwp"};